import { useMe } from '@capsicum/socios-core';

import { usePlaceOrderQuery, useProductCheckoutStartQuery } from '../data-access/queries';

import { useCheckoutErrorHandler, type UseCheckoutErrorHandlerProps } from './useCheckoutErrorHandler';

type UseProductCheckoutProps = Omit<UseCheckoutErrorHandlerProps, 'error'>;

export const useProductCheckout = ({ onFailedCheckout }: UseProductCheckoutProps = {}) => {
	const { isMeLoading, me } = useMe();

	const {
		data: checkoutInfo,
		error: checkoutError,
		isPending,
		mutateAsync: startCheckout
	} = useProductCheckoutStartQuery();

	useCheckoutErrorHandler({ error: checkoutError, onFailedCheckout });

	const { data: completeCheckoutData, mutateAsync: mutatePlaceOrder } = usePlaceOrderQuery();

	return {
		checkoutError,
		checkoutInfo,
		completeCheckoutData,
		isLoading: isPending,
		isMeLoading,
		me,
		mutatePlaceOrder,
		startCheckout
	};
};
